import api from './api';

export const studentsAPI = {
  getStudetsByParams: (params = {}) => api.get(`/students/get-students-by-params`, { params }),
  addStudent: (studentData) => api.post(`/students/add-student`, studentData),
  updateStudent: (studentId, studentData) => api.post(`/students/update-student/${studentId}`, studentData),
  deleteStudent: (studentId) => api.delete(`/students/delete-student/${studentId}`),
};